import { FC, useState } from "react";

import { SectionScorePanel } from "./SectionScorePanel";
import { StudentPerformancePanel } from "./StudentPerformancePanel";

import { AllAssessmentDashboard } from "components/materials/section/assessment/AllAssessmentDashboard";
import { t } from "i18n/i18n";
import type { ResourceKey } from "i18n/i18next";
import { IconText } from "mds/components/IconText";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { BookSectionIcon, PageIcon, PersonClassIcon } from "mds/icons";

type InstructorViewType = "all" | "section_scores" | "student_performance";

export const InstructorAssessmentView: FC = () => {
  const [selectedView, setSelectedView] = useState<InstructorViewType>("all");

  const viewTabs: { view: InstructorViewType; icon: React.ReactNode; labelKey: ResourceKey }[] = [
    { view: "all", icon: <PageIcon />, labelKey: "assessment_dashboard.all.title" },
    {
      view: "section_scores",
      icon: <BookSectionIcon />,
      labelKey: "assessment_dashboard.section_scores",
    },
    {
      view: "student_performance",
      icon: <PersonClassIcon />,
      labelKey: "assessment_dashboard.student_performance",
    },
  ];

  const viewContent: Record<InstructorViewType, React.ReactNode> = {
    all: <AllAssessmentDashboard />,
    section_scores: <SectionScorePanel />,
    student_performance: <StudentPerformancePanel />,
  };

  return (
    <>
      <div className="flex gap-2">
        {viewTabs.map(({ view, icon, labelKey }) => (
          <SquareButton
            isSelected={selectedView === view}
            key={view}
            kind="secondary"
            size="s"
            onClick={() => setSelectedView(view)}
          >
            <IconText iconStart={icon} text={t(labelKey)} />
          </SquareButton>
        ))}
      </div>

      {viewContent[selectedView]}
    </>
  );
};
